export default "__VITE_ASSET__9f0a575e__"